import configs from "./configs";

const { REACT_APP_CONFIG } = process.env;
const config = configs[REACT_APP_CONFIG] || configs.sbm;

// Set the correct title
document.title = config.title;
export default config;
